import React from "react";
import ReactApexChart from "react-apexcharts";

const FacultyPerUniversityChart = ({ data = [], categories = [] }) => {
  const series = [
    {
      name: "عدد هيئة التدريس",
      data: data,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "13%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val} عضو`,
      style: {
        fontSize: "12px",
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: "الجامعة",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
      },
      title: {
        // text: "عدد هيئة التدريس",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
    },
    colors: ["#28a745"],
    tooltip: {
      y: {
        formatter: (val) => `${val} عضو`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3">عدد أعضاء هيئة التدريس في الجامعات</h5>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default FacultyPerUniversityChart;
